import(/* webpackMode: "eager" */ "C:\\Users\\e.alseddiq\\Projects\\FintekWebsite\\app\\global-error.tsx")